// This service controls how the campaign stepper works

import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CampaignStepperService {
router = inject(Router)
route = inject(ActivatedRoute)
steps = [
    {text: 'Campaign Details', slug: 'campaign-details', completed: false},
    {text: 'Recipients', slug: 'recipients', completed: false},
    {text: 'Messages', slug: 'messages', completed: false},
    {text: 'Schedule', slug: 'schedule', completed: false},
    {text: 'Review', slug: 'review', completed: false},
 ]

  constructor() { }

  // function to mark step as completed
  stepCompleted(step: string){
    this.steps.forEach(item => {
      if (item.slug === step) {
          item.completed = true;
      }
  });
  }

  // function to find step that is yet to be completed and return it's slug
  nextStep() {
    for (let i = 0; i < this.steps.length; i++) {
        if (!this.steps[i].completed) {
            return this.steps[i].slug;
        }
    }
    return null; // Return null if all steps are completed
}

// function to find next step to navigate to after completion
getNextStep(slug: string) {
  // Find the index of the current step
  const currentIndex = this.steps.findIndex(item => item.slug === slug);

  // If the step is not found or it's the last step, return null
  if (currentIndex === -1 || currentIndex === this.steps.length - 1) {
    throw new Error("slug parameter provided to getNextStep function is non existent")
  }

  // Return the next item in the array
  return this.steps[currentIndex + 1].slug;
}

// function to move to next step...
moveToNextStep(currentStep: string) {
  this.router.navigate([], {
    relativeTo: this.route, // Stay on the current route
    queryParams: { step: this.getNextStep(currentStep) }, // Add the new query param
  });
}

reset() {
  this.steps.forEach(item => {
        item.completed = false;
});
}

}
